<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <!-- <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button> -->
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          label-width="120px"
          :model="form"
          @submit.native.prevent
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <!-- <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" class="fl" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="翻译配置">
            <el-radio-group v-model="form.config.translate">
              <el-radio label="chatgpt">chatgpt</el-radio>
              <el-radio label="volc">火山引擎</el-radio>
              <el-radio label="tongYi">通义</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="AI用量统计">
            <el-radio-group v-model="form.config.usageRecord">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="阅读统计是否开启">
            <el-radio-group v-model="form.config.statistics">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="阅读AI助手配置">
            <el-radio-group v-model="form.config.readingAI.model">
              <el-radio
                v-for="item in aiModelOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {
    isOversea() {
      const host = window.location.hostname;
      return /^(en|ru|eur)-/.test(host);
    },
    aiModelOptions() {
      if (!this.isOversea) {
        return [
          {
            value: "qwen3.5-plus",
            label: "qwen3.5-plus(通义)",
            engine: "tongyi",
          },
        ];
      }
      return [
        {
          value: "google/gemini-3-flash-preview",
          label: "gemini-3-flash-preview(gemini)",
          engine: "gemini",
        },
      ];
    },
    defaultReadingAI() {
      const first = this.aiModelOptions[0];
      return { model: first.value, engine: first.engine };
    },
  },
  watch: {
    "form.config.readingAI.model"(val) {
      const matched = this.aiModelOptions.find((item) => item.value === val);
      if (matched) {
        this.form.config.readingAI.engine = matched.engine;
      }
    },
  },
  data() {
    return {
      form: {
        config: {
          translate: "",
          usageRecord: "yes",
          statistics: "yes",
          readingAI: { model: "", engine: "" },
        },
      },
      rules: {},
    };
  },
  methods: {
    async getDetails() {
      let res = await this.$http.getSysSettingsDetails();
      this.form.config = res.data.config
        ? res.data.config
        : {
            translate: "",
            usageRecord: "yes",
            statistics: "yes",
            readingAI: { ...this.defaultReadingAI },
          };
      if (!this.form.config.readingAI) {
        this.form.config.readingAI = { ...this.defaultReadingAI };
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.create();
        } else {
          return false;
        }
      });
    },

    async create() {
      await this.$http.updateSysSettingsDetails(this.form);
      this.getDetails();
      this.$message({
        type: "success",
        message: this.$t("alertMsg.addSuccess"),
      });
    },
  },
  async mounted() {
    this.getDetails();
  },
};
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      .parms-list + .parms-list {
        margin-top: 10px;
      }
      .parms-list {
        display: flex;
        > .el-input {
          width: 40%;
          max-width: 300px;
          margin-right: 10px;
        }
        > span {
          width: 30px;
          height: 35px;
          line-height: 32px;
          text-align: center;
          display: inline-block;
          font-size: 20px;
          vertical-align: bottom;
          cursor: pointer;
          color: #555;
        }
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
</style>
